var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6299 0.5C0.757779 0.5 0.0507812 1.26745 0.0507812 2.21415V18.6428C0.0507812 18.8072 0.0943107 18.968 0.176181 19.1063C0.411985 19.5045 0.900497 19.6197 1.2673 19.3638L5.57613 16.3559H17.4211C18.2932 16.3559 19.0002 15.5884 19.0002 14.6417V2.21415C19.0002 1.26745 18.2932 0.5 17.4211 0.5H1.6299Z",
    fill: "#008187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBubble);
export default __webpack_public_path__ + "static/media/helpBubble.5e165e73fabb0e11f3529c5a84cf177b.svg";
export { ForwardRef as ReactComponent };